import { createSelector, createSlice } from '@reduxjs/toolkit'
import { fetchServingOrder } from '~/apis/orderHistory'

const initValue = {
  loading: true,
  error: null,
  data: {},
  request: false,
}

const orderHistorySlice = createSlice({
  name: 'orderHistory',
  initialState: initValue,
  reducers: {
    resetStatePayment: () => initValue,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchServingOrder.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchServingOrder.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(fetchServingOrder.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.data = {}
      })
  },
})

export const { resetStatePayment } = orderHistorySlice.actions
export const selectOrderHistory = (state) => state.orderHistory

// Bọc createSelector để tối ưu performance
export const orderHistorySelector = createSelector(
  selectOrderHistory,
  (orderHistory) => orderHistory,
)

export default orderHistorySlice.reducer
